import { Navigate } from 'src/lib/routing';

export const RedirectToTeams = () => <Navigate to="/teams" replace />;
